import { imagePlaceholder, textPlaceHolder } from "./placeholders";
class RenderElement {
    props = null;
    editor = false;
    setProps = (props) => {
        this.props = props;
        return this;
    };
    setEditor = (value) => {
        this.editor = value;
    };
    returnProps = (props) => {
        const rProps = props;
        if (!this.editor) {
            Object.keys(rProps)
                .filter((key) => {
                if (["editor-link-label"].includes(key))
                    return false;
                return key.startsWith(`editor-`);
            })
                .forEach((key) => {
                delete rProps[key];
            });
        }
        return rProps;
    };
    renderClassName = (key, fallback = "", options = null, additional = "") => {
        let classNames = (this.props?.[key]?.className || fallback) + ` ${additional}`;
        let animation = this.props?.[key]?.animation;
        const editorOptions = {};
        if (options?.backgroundColor) {
            if (this.props?.[key]?.backgroundColor) {
                classNames += ` ${this.props?.[key]?.backgroundColor} `;
                editorOptions["editor-backgroundcolor"] =
                    this.props?.[key]?.backgroundColor;
            }
            else {
                classNames += ` ${options?.backgroundColor}`;
                editorOptions["editor-backgroundcolor"] = options?.backgroundColor;
            }
        }
        if (options?.textSize) {
            if (this.props?.[key]?.textSize) {
                classNames += ` ${this.props?.[key]?.textSize}`;
                editorOptions["editor-textsize"] = this.props?.[key]?.textSize;
            }
            else {
                classNames += ` ${options?.textSize}`;
                editorOptions["editor-textsize"] = options?.textSize;
            }
        }
        if (animation && animation.selected !== "disabled") {
            editorOptions["editor-animation-selected"] = animation.selected;
            editorOptions["data-aos"] = `animate__${animation.selected}`;
            if (this.editor) {
                classNames += ` animate__animated animate__${animation.selected}`;
            }
        }
        return this.returnProps({
            className: classNames,
            ...editorOptions,
        });
    };
    renderText = (key, fallback = textPlaceHolder.value) => {
        const propsResult = this.props?.[key]?.text;
        if (propsResult) {
            return this.returnProps(propsResult);
        }
        return this.returnProps(fallback);
    };
    renderImage = (key, fallback = {}) => {
        const propsResult = this.props?.[key]?.image;
        if (propsResult) {
            return this.returnProps({
                src: propsResult.src,
                alt: propsResult.alt,
                "editor-img-placeholder": propsResult.placeholder.toString(),
                "editor-img-file": propsResult.file,
            });
        }
        return this.returnProps({
            src: imagePlaceholder.src,
            alt: imagePlaceholder.alt,
            "editor-img-placeholder": imagePlaceholder.placeholder.toString(),
            "editor-img-file": imagePlaceholder.file,
            ...fallback,
        });
    };
    renderLink = (key, fallback = null) => {
        const propsResult = this.props?.[key]?.link;
        if (propsResult) {
            return this.returnProps({
                href: propsResult.href,
                target: propsResult.target,
                page: propsResult.page,
                "editor-link-label": propsResult.label,
                "editor-link-type": propsResult.type,
                "editor-link-page": propsResult.page,
            });
        }
        return this.returnProps({
            href: "#",
            "editor-link-label": "Link tekst",
            "editor-link-type": "link",
        });
    };
    renderMenu = (key) => {
        const propsResult = this.props?.[key]?.menu;
        if (propsResult) {
            return this.returnProps(propsResult);
        }
        return this.returnProps({
            selected: null,
        });
    };
    renderForm = (key) => {
        const propsResult = this.props?.[key]?.form;
        if (propsResult) {
            return this.returnProps(propsResult);
        }
        return this.returnProps({
            selected: null,
            button: "Verstuur",
        });
    };
    renderBackgroundImage = (key, prop) => {
        const propsResult = this.props?.[key]?.[prop];
        if (propsResult) {
            return this.returnProps({
                src: propsResult.src,
                "editor-background-image-src": propsResult.src,
                "editor-background-image-alt": propsResult.alt,
                "editor-background-image-placeholder": propsResult.placeholder.toString(),
                "editor-background-image-file": propsResult.file,
            });
        }
        return this.returnProps({
            src: imagePlaceholder.src,
            "editor-background-image-src": imagePlaceholder.src,
            "editor-background-image-placeholder": imagePlaceholder.placeholder.toString(),
            "editor-background-image-file": imagePlaceholder.file,
        });
    };
    renderIcon = (key, fallback = { name: "", variant: "outline" }) => {
        const propsResult = this.props?.[key];
        if (propsResult) {
            return this.returnProps({
                name: propsResult.iconName,
                variant: propsResult.iconVariant,
            });
        }
        return this.returnProps({
            name: fallback.name,
            variant: fallback.variant,
        });
    };
    renderProp = (key, prop) => {
        const propsResult = this.props?.[key]?.[prop];
        if (propsResult) {
            return this.returnProps(propsResult);
        }
        return null;
    };
    renderAttributeOptions = (options = [], parentKey = null) => {
        const dataProps = {};
        options.forEach((option) => {
            if (option.config && option.config.key && parentKey) {
                const value = this.renderProp(parentKey, option.config.key)?.[option.config.valueKey || "value"] || option.config.defaultValue;
                dataProps[`editor-${option.config.key}`] = value;
                if (option.config?.repeatableOptions) {
                    option.config?.repeatableOptions.forEach((o) => {
                        dataProps[`repeatable-${o.key}`] = this.renderProp(parentKey, `repeatable-${o.key}`);
                    });
                }
            }
        });
        return this.returnProps({
            "editor-options": JSON.stringify(options),
            ...dataProps,
        });
    };
    renderRepeatDeleteKey = (element, group, index) => {
        return this.returnProps({
            "editor-deletekey": `${element}|${group}|${index}`,
        });
    };
}
export default new RenderElement();
//# sourceMappingURL=RenderElement.js.map